import React, { useEffect, useState } from 'react';
import baseURL from '../url';
import './BannersTiendas.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'react-toastify/dist/ReactToastify.css';
import LoadingTiendas from '../LoadingTiendas/LoadingTiendas';
import { Link as Anchor } from "react-router-dom";

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function BannersTiendas() {
    const [loading, setLoading] = useState(true);
    const [tiendas, setTiendas] = useState([]);

    useEffect(() => {
        cargarTiendas();
    }, []);

    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    const cargarTiendas = async () => {
        let tiendasData = [];
        try {
            const response = await fetch(`${baseURL}/tiendasFrontend.php`, { method: 'GET' });
            const data = await response.json();
            if (Array.isArray(data?.tiendas) && data.tiendas.length > 0) {
                tiendasData = data.tiendas;
            }
        } catch (error) {
            console.warn('tiendasFrontend.php falló en BannersTiendas, usando tiendaGet.php...', error);
        }

        if (tiendasData.length === 0) {
            try {
                const fallbackRes = await fetch(`${baseURL}/tiendaGet.php`, { method: 'GET' });
                const fallbackData = await fallbackRes.json();
                if (Array.isArray(fallbackData?.tiendas)) {
                    tiendasData = fallbackData.tiendas.filter(t => !t.estado || t.estado === 'visible');
                }
            } catch (errFallback) {
                console.error('Error al cargar banners tiendas fallback:', errFallback);
            }
        }

        const tiendasAleatorias = shuffleArray(tiendasData).slice(0, 4);
        setTiendas(tiendasAleatorias);
        setLoading(false);
    };

    return (
        <div className='BannersTiendas' >
            {loading ? (
                <Swiper
                    grabCursor={true}
                    id='swiper_container_tiendas'
                    autoplay={{ delay: 3500 }}
                    spaceBetween={16}
                    breakpoints={{
                        320: { slidesPerView: 1.2, spaceBetween: 10 },
                        480: { slidesPerView: 2.1, spaceBetween: 12 },
                        768: { slidesPerView: 3.1, spaceBetween: 14 },
                        1024: { slidesPerView: 4, spaceBetween: 16 }
                    }}
                >
                    <SwiperSlide id='SwiperSlide-scroll-banner-tiendasLoading' />
                    <SwiperSlide id='SwiperSlide-scroll-banner-tiendasLoading' />
                    <SwiperSlide id='SwiperSlide-scroll-banner-tiendasLoading' />
                    <SwiperSlide id='SwiperSlide-scroll-banner-tiendasLoading' />
                </Swiper>
            ) : (
                <Swiper
                    grabCursor={true}
                    id='swiper_container_tiendas'
                    autoplay={{ delay: 3500, disableOnInteraction: false }}
                    spaceBetween={16}
                    breakpoints={{
                        320: { slidesPerView: 1.2, spaceBetween: 10 },
                        480: { slidesPerView: 2.1, spaceBetween: 12 },
                        768: { slidesPerView: 3.1, spaceBetween: 14 },
                        1024: { slidesPerView: 4, spaceBetween: 16 }
                    }}
                >
                    {tiendas.map(item => (
                        <SwiperSlide id='SwiperSlide-scroll-banner-tiendas' key={item.idTienda}>
                            <Anchor to={`/tienda/${item.idTienda}/${item.nombre.replace(/\s+/g, '-')}`}>
                                <img
                                    src={item.imagen2}
                                    alt={`Tienda ${item.nombre}`}
                                    className='imgTiendaBanner'
                                    loading="lazy"
                                    decoding="async"
                                    width="300"
                                    height="160"
                                />
                                <div className="bannerTiendaOverlay">
                                    <span className="bannerTiendaNombre">{item.nombre}</span>
                                </div>
                            </Anchor>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </div>
    );
}
